export default __webpack_public_path__ + "static/media/ar.bbeff8ae.svg";